"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveScheduleCms = void 0;
var LiveScheduleCms = /** @class */ (function () {
    function LiveScheduleCms() {
        this.liveCalenderDateLabel = 'Date: ';
        this.liveCalenderAppointmentTimeSelectionLabel = 'Technician\'s arrival window:&nbsp;';
        this.firstAvailableAppointmentLabel = 'Here\'s our first available appointment.';
        this.liveCalenderAppointmentTimeSelectionToolTip = "Your technician's arrival time is flexible. The time ranges\n     listed reflect the technician's arrival window and not the length of\n      the installation. Depending on services ordered, a standard installation\n       takes an average of 4 hours from the time your technician arrives.";
        this.firstAvailableAppointment = "First available appointment:";
    }
    return LiveScheduleCms;
}());
exports.LiveScheduleCms = LiveScheduleCms;
//# sourceMappingURL=LiveSchedule.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/InstallationCard/LiveSchedule/LiveSchedule.cms.js
// module id = 960
// module chunks = 8